<template>
  <b-card class="pending-order-card mb-2" no-body>
    <b-card-body class="p-3">
      <div class="d-flex justify-content-between align-items-start mb-2">
        <div>
          <span class="pending-order-card__order-no">{{ order.order_no }}</span>
          <span class="pending-order-card__date ml-2">{{ formattedDate }}</span>
        </div>
        <b-badge variant="info" class="pending-order-card__status">
          {{ order.status ? order.status.name : 'Pending' }}
        </b-badge>
      </div>
      <div class="pending-order-card__products mb-2">
        <div
          v-for="product in order.products"
          :key="product.id"
          class="pending-order-card__product-line"
        >
          {{ product.name }} x{{ product.pivot.quantity }}
        </div>
      </div>
      <div class="d-flex justify-content-between align-items-center">
        <span class="pending-order-card__total">R{{ formattedTotal }}</span>
        <b-button
          variant="primary"
          class="pending-order-card__handover-btn"
          :disabled="handovering"
          @click="$emit('handover', order.id)"
        >
          <b-spinner v-if="handovering" small class="mr-1" />
          {{ handovering ? 'Handing over...' : 'Hand Over' }}
        </b-button>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  name: 'pendingOrderCard',
  props: {
    order: {
      type: Object,
      required: true,
    },
    handovering: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    formattedDate() {
      if (!this.order.created_at) return '';
      const d = new Date(this.order.created_at);
      return d.toLocaleDateString('en-ZA', { day: 'numeric', month: 'short' })
        + ' ' + d.toLocaleTimeString('en-ZA', { hour: '2-digit', minute: '2-digit' });
    },
    formattedTotal() {
      const total = parseFloat(this.order.order_total) || 0;
      return total.toFixed(2);
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/design/tokens/brand";
@import "~@/design/tokens/surfaces";
@import "~@/design/tokens/typography";
@import "~@/design/tokens/spacing";
@import "~@/design/tokens/feedback";

.pending-order-card {
  background: $surface-elevated;
  border: 1px solid $border-default;

  &__order-no {
    font-family: $font-family-mono;
    font-size: $type-body;
    font-weight: 600;
    color: $text-primary;
  }

  &__date {
    font-size: $type-small;
    color: $text-muted;
  }

  &__status {
    font-size: $type-badge;
  }

  &__products {
    font-size: $type-small;
    color: $text-secondary;
  }

  &__product-line {
    padding: 1px 0;
  }

  &__total {
    font-size: $type-body-lg;
    font-weight: 600;
    color: $text-primary;
  }

  &__handover-btn {
    min-height: 44px;
    min-width: 120px;
    font-weight: 600;
    background: $brand-primary;
    border-color: $brand-primary;

    &:hover:not(:disabled) {
      background: $brand-primary-dark;
      border-color: $brand-primary-dark;
    }

    &:disabled {
      opacity: 0.65;
      cursor: not-allowed;
    }

    &:focus-visible {
      outline: 2px solid $brand-primary;
      outline-offset: 2px;
    }
  }
}
</style>
